var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/ic_edit.4422ff4a.png","uri@2x": __webpack_public_path__ + "static/media/ic_edit.1d97d3b9.png","uri@3x": __webpack_public_path__ + "static/media/ic_edit.ca9a09bd.png",
    width: 18,
    height: 18
});